

import React from "react";
import { Box, Grid, Typography, Paper, useTheme } from "@mui/material";
import { LocalShipping } from "@mui/icons-material";
import { twMerge } from "tailwind-merge";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";

const CustomerAnalyticOverview = ({ statsData, isLoading }) => {
  const theme = useTheme(); // Access the theme (dark or light)

  const stats = [
    {
      title: "Total Shipments",
      count: statsData?.totalShipments ?? 0,
      link: "/app/customer/customer-shipment?tab=Active",
      icon: <LocalShipping fontSize="large" className="text-blue-600" />,
    },
    {
      title: "Pending Shipments",
      count: statsData?.pendingShipments ?? 0,
      link: "/app/customer/customer-shipment?tab=Pending",
      icon: <LocalShipping fontSize="large" className="text-yellow-600" />,
    },
    {
      title: "Scheduled Shipments",
      count: statsData?.scheduledShipments ?? 0,
      icon: <LocalShipping fontSize="large" className="text-teal-600" />,
    },
    {
      title: "Delivered Shipments",
      count: statsData?.deliveredShipments ?? 0,
      link: "/app/customer/customer-shipment?tab=Delivered",
      icon: <LocalShipping fontSize="large" className="text-green-600" />,
    },
  ];

  if (isLoading) return <InfoGridSkeleton />;

  return (
    <Box className="px-5 py-2">
      <Grid container spacing={3}>
        {stats.map((stat, index) => (
          <Grid
            key={index}
            item
            xs={12}
            sm={6}
            md={3}
            sx={{
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "&:hover": { transform: "scale(1.02)" },
            }}
          >
            {/* Make the whole card clickable */}
            <a href={stat.link} style={{ textDecoration: "none" }}>
              <Paper
                className={twMerge(
                  "relative overflow-hidden rounded-lg shadow-lg transition-all duration-300 cursor-pointer",
                  theme.palette.mode === "dark" ? "bg-gray-800" : "bg-white"
                )}
                sx={{
                  border: `1px solid ${theme.palette.mode === "dark" ? "#333" : "#ccc"}`, // Adjust border color based on theme
                  padding: "10px",
                  borderRadius: "15px",
                }}
              >
                {/* Smaller overlay box */}
                <div className="absolute inset-0 bg-white opacity-10 dark:bg-black dark:opacity-20"></div>

                <Box
                  className="p-4"
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  height="100%"
                >
                  {/* Display text with color change based on theme */}
                  <Typography
                    variant="h6"
                    fontWeight="medium"
                    className={`text-center mb-2 ${theme.palette.mode === "dark" ? "text-white" : "text-gray-800"}`}
                    style={{ fontSize: "1.2rem" }}
                  >
                    {stat.title}
                  </Typography>

                  <Typography
                    variant="h4"
                    fontWeight="bold"
                    className={`text-center mb-3 ${theme.palette.mode === "dark" ? "text-white" : "text-gray-900"}`}
                    style={{ fontSize: "1.2rem" }}
                  >
                    {stat.count}
                  </Typography>

                  {/* Always show the icon */}
                  <Box className="mt-2">{stat.icon}</Box>
                </Box>
              </Paper>
            </a>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CustomerAnalyticOverview;